import { Box, SxProps, Theme } from '@mui/material';

const rootStyles: SxProps<Theme> = {
  maxWidth: '250px',
  height: 'auto',
};

export default function ZeptoLogo() {
  return <Box component='img' sx={rootStyles} src='' alt='' />;
}
